export default [
	{ text: 'NSW', value: 'NSW' },
	{ text: 'QLD', value: 'QLD' },
	{ text: 'SA', value: 'SA' },
	{ text: 'TAS', value: 'TAS' },
	{ text: 'VIC', value: 'VIC' },
	{ text: 'WA', value: 'WA' },
	{ text: 'ACT', value: 'ACT' },
	{ text: 'NT', value: 'NT' }
];



// WEBPACK FOOTER //
// ./src/data/states.js